import { FC, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import OverviewInfo from "./OverviewInfo";
import ResourcesManagement from "./ResourcesManagement";
import RolesManagement from "./RolesManagement";
import Users from "./Users";

import CreateIcon from "@mui/icons-material/Create";
import TextField from "@mui/material/TextField";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

import BatchPredictionIcon from "@mui/icons-material/BatchPrediction";
import { connect, ConnectedProps } from "react-redux";
import { AppState } from "../../../../redux/store";

import {
  fetchProjectsOverview,
  setShowEditProjectDesc,
  setShowEditProjectName,
  editProjectById,
} from "../../../../redux/projectsManagement/actions";
import Acl from "../../subcomponents/Acl";
import { PERMISSION_LIST } from "../../../../constants";
import { LoadingAnimation } from "../../subcomponents/LoadingAnimation";

const mapStateToProps = (state: AppState) => ({
  selectedProject: state.projectsManagement.selectedProject,
  isProjectDetailsLoading: state.projectsManagement.isProjectDetailsLoading,
  projectData: state.projectsManagement.projectsOverviewDetails,
  showEditProjectName: state.projectsManagement.showEditProjectName,
});

const mapDispatchToProps = {
  setShowEditProjectDesc,
  setShowEditProjectName,
  fetchProjectsOverview,
  editProjectById,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type Props = ConnectedProps<typeof connector>;

const ProjectsDetils: FC<Props> = ({
  selectedProject,
  showEditProjectName,
  projectData,
  isProjectDetailsLoading,
  fetchProjectsOverview,
  setShowEditProjectName,
  setShowEditProjectDesc,
  editProjectById,
}) => {
  const [value, setValue] = useState("1");
  const [error, setError] = useState(false);
  const [name, setName] = useState(projectData.name);
  const handleChange = (_, newValue: string) => {
    setValue(newValue);
  };

  const handleEditSave = () => {
    let payload = { name: name, description: projectData.description };
    if (name.trim().length === 0) {
      setError(true);
    } else {
      setError(false);
      setShowEditProjectName(false);
      editProjectById(selectedProject.projectId, payload);
    }
  };

  useEffect(() => {
    fetchProjectsOverview(selectedProject.projectId);
  }, [fetchProjectsOverview, selectedProject.projectId]);

  useEffect(() => {
    setName(projectData.name);
  }, [projectData, setShowEditProjectName]);

  useEffect(() => {
    setShowEditProjectName(false);
  }, [setShowEditProjectName]);

  if (isProjectDetailsLoading) return <LoadingAnimation />;
  return (
    <>
      <div style={{ display: "flex" }}>
        <BatchPredictionIcon
          style={{
            color: "#0A85C7",
            fontSize: 32,
            marginTop: 8,
            marginLeft: 20,
          }}
        />
        {!showEditProjectName && (
          <>
            {" "}
            <Typography
              style={{
                fontStyle: "normal",
                fontWeight: 600,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: 34,
                lineHeight: 1.5,
                textAlign: "left",
                color: "#0A85C7",
                marginLeft: 10,
                marginBottom: 0,
                marginTop: "auto",
              }}
            >
              {projectData.name}
            </Typography>
            <Acl permission={PERMISSION_LIST.PROJECTS_WRITE}>
              <CreateIcon
                id={"editProject"}
                sx={{
                  "&:hover": { color: "#0A85C7" },
                  cursor: "pointer",
                  color: "#02273C",
                }}
                style={{ height: 19, width: 19, marginTop: 8, marginLeft: 10 }}
                onClick={() => {
                  setShowEditProjectName(true);
                  setShowEditProjectDesc(false);
                }}
              />
            </Acl>
          </>
        )}
        {showEditProjectName && (
          <div style={{ display: "flex" }}>
            <TextField
              style={{
                width: "100%",
                height: 46,
                background: "#F6FDFF",
                margin: "0.313rem 0 0.313rem 0",
              }}
              id="outlined-helperText"
              background-color="white"
              value={name}
              size="small"
              inputProps={{ maxLength: 40 }}
              error={error}
              helperText={error ? "Valid Value is required." : ""}
              onChange={(e) => setName(e.target.value)}
            />
            <div
              style={{
                display: "flex",
                padding: "0.625rem 0.625rem 0 0.625rem",
                columnGap: "0.625rem",
                alignItems: "end",
              }}
            >
              <CheckIcon
                sx={{
                  "&:hover": { color: "#0A85C7" },
                  width: 34,
                  height: 34,
                  cursor: "pointer",
                }}
                id={"editSave"}
                onClick={handleEditSave}
              />
              <CloseIcon
                sx={{
                  "&:hover": { color: "#0A85C7" },
                  width: 34,
                  height: 34,
                  cursor: "pointer",
                }}
                id={"closeProject"}
                onClick={() => {
                  setShowEditProjectName(false);
                }}
              />
            </div>
          </div>
        )}
      </div>
      <Box sx={{ width: "100%", height: 700, typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              style={{ marginLeft: "0" }}
            >
              <Tab label="Project Overview" value="1" />
              <Tab label="Resources" value="2" />
              <Tab label="Roles" value="3" />
              <Tab label="Users" value="4" />
            </TabList>
          </Box>
          <TabPanel
            value="1"
            style={{
              height: "46.875rem",
              overflowY: "auto",
            }}
          >
            <OverviewInfo />
          </TabPanel>
          <TabPanel
            value="2"
            style={{
              height: "46.875rem",
              overflowY: "auto",
            }}
          >
            <ResourcesManagement />
          </TabPanel>
          <TabPanel
            value="3"
            style={{
              height: "46.875rem",
              overflowY: "auto",
            }}
          >
            <RolesManagement />
          </TabPanel>
          <TabPanel
            value="4"
            style={{
              height: "46.875rem",
              overflowY: "auto",
            }}
          >
            <Users />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};

export default connector(ProjectsDetils);
